import React from 'react'
import { Button } from '@grammarly/badger-ui'
import cn from 'classnames'

import { PlayIcon } from './play_icon'
import { PauseIcon } from './pause_icon'
import { assertNever } from '../../lib/utils/assert-never'
import style from './style.module.scss'
import { Color23 } from '@grammarly/badger-ui'

type PlayPauseState = 'playing' | 'paused' | 'inactive'

interface PlayPauseButtonProps {
  state: PlayPauseState
  onClick: () => void
  ariaLabel?: string
  backgroundColor?: string
  color?: Color23
}

const getDefaultAriaLabel = (state: PlayPauseState): string => {
  switch (state) {
    case 'playing':
      return 'Pause'
    case 'paused':
      return 'Play'
    case 'inactive':
      return ''
    default:
      assertNever(state)
      return ''
  }
}

interface IconProps {
  isPlaying: boolean
  fill?: string
  color?: Color23
}
const Icon: React.FC<IconProps> = ({ isPlaying, fill, color }) =>
  isPlaying ? <PauseIcon fill={fill} color={color} /> : <PlayIcon fill={fill} color={color} />

export const PlayPauseButton: React.FC<PlayPauseButtonProps> = ({
  onClick,
  state,
  ariaLabel,
  backgroundColor,
  color,
  ...props
}) => {
  ariaLabel = ariaLabel ?? getDefaultAriaLabel(state)
  const inactive = state === 'inactive'

  return (
    <Button
      status={inactive ? 'disabled' : 'enabled'}
      padding="none"
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className={cn(inactive && style.inactive)}
      {...props}
    >
      <Icon isPlaying={state === 'playing'} fill={backgroundColor} color={color} />
    </Button>
  )
}
